import { render, staticRenderFns } from "./SchoolOrgModal.vue?vue&type=template&id=76f973d6&scoped=true"
import script from "./SchoolOrgModal.vue?vue&type=script&lang=js"
export * from "./SchoolOrgModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76f973d6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76f973d6')) {
      api.createRecord('76f973d6', component.options)
    } else {
      api.reload('76f973d6', component.options)
    }
    module.hot.accept("./SchoolOrgModal.vue?vue&type=template&id=76f973d6&scoped=true", function () {
      api.rerender('76f973d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/school/schoolOrg/modules/SchoolOrgModal.vue"
export default component.exports